import { render, staticRenderFns } from "./detail-infringement.vue?vue&type=template&id=03403b72&"
import script from "./detail-infringement.vue?vue&type=script&lang=js&"
export * from "./detail-infringement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports